// import { Task } from "@/types/task";
import { ModelPublishParams, ModelResult, ModelTrainingParams, MyModel, MyModelDetail, Tagger, TrainingPicture } from "@/types/creatorcenter";
import { ResultOk } from "@/types/resultok";
import { api } from "..";
import { buildQueryString } from "./utils";

export const userApi = api.injectEndpoints({
  endpoints: (build) => ({
    // 新建训练任务
    createTrain: build.mutation<any, { userId: string; train_status: string }>({
      query: ({ userId, train_status }) => ({
        url: `/models/train/create`,
        method: "POST",
        body: {
          user_id: userId,
          train_status: train_status,
        },
      }),
      transformErrorResponse: (baseQueryReturnValue, meta, arg) => baseQueryReturnValue.data,
      // invalidatesTags: ["UserSign"],
    }),
    // 打标
    tagger: build.mutation<ResultOk, { userId: string; threshold: number; additional_tags: string; images: string[]; train_id: string; width: number; height: number }>({
      query: (body) => ({
        url: `/models/tagger`,
        method: "POST",
        body,
      }),
      transformErrorResponse: (baseQueryReturnValue, meta, arg) => baseQueryReturnValue.data,
    }),

    // 更新标签
    updateTagger: build.mutation<ResultOk, { userId: string; tagger: Tagger[] }>({
      query: ({ userId, tagger }) => ({
        url: `/models/tagger/update`,
        method: "POST",
        body: {
          userId,
          tagger,
        },
      }),
      transformErrorResponse: (baseQueryReturnValue, meta, arg) => baseQueryReturnValue.data,
    }),

    // 打标-查询
    taggerSearch: build.mutation<TrainingPicture[], string[]>({
      query: (pictureIds) => ({
        url: `/models/tagger/search`,
        method: "POST",
        body: pictureIds,
      }),
      transformErrorResponse: (baseQueryReturnValue, meta, arg) => baseQueryReturnValue.data,
    }),

    // 训练
    train: build.mutation<ResultOk, { userId: string; trainId: string; trainingParams: ModelTrainingParams,trigger_word:string }>({
      query: ({ userId, trainId, trainingParams,trigger_word }) => ({
        url: `/models/train`,
        method: "POST",
        body: {
          userId,
          trainId,
          trigger_word,
          ...trainingParams,
        },
      }),
      transformErrorResponse: (baseQueryReturnValue, meta, arg) => baseQueryReturnValue.data,
      invalidatesTags: ["Train"]
    }),

    // 根据train_id查询训练
    getTrainById: build.query<ModelResult, { train_id: string }>({
      query: (params) => `/models/train${buildQueryString(params)}`,
      transformErrorResponse: (baseQueryReturnValue, meta, arg) => baseQueryReturnValue.data,
      providesTags:["Train"]
    }),

    // 模型训练发布
    trainPublish: build.mutation<ResultOk, ModelPublishParams>({
      query: (modelPublishParams) => ({
        url: `/models/train/publish`,
        method: "POST",
        body: modelPublishParams,
      }),
      transformErrorResponse: (baseQueryReturnValue, meta, arg) => baseQueryReturnValue.data,
    }),

    // 模型训练列表
    getTrains: build.query<MyModelDetail[], { user_id: string }>({
      query: ({ user_id }) => `/models/trains?user_id=${user_id}`,
      transformErrorResponse: (baseQueryReturnValue, meta, arg) => baseQueryReturnValue.data,
      providesTags:["Train"]
    }),

    //删除打标图片
    deleteTagger:build.mutation<ResultOk,{userId:string, fileIds: string[]}>({
      query: (body) => ({
        url: `/models/tagger/delete`,
        method: 'POST',
        body,
      }),
      transformErrorResponse: (baseQueryReturnValue, meta, arg) => baseQueryReturnValue.data,
    }),

  }),
});

export const { 
  useCreateTrainMutation, 
  useTaggerMutation, 
  useTaggerSearchMutation, 
  useTrainMutation, 
  useGetTrainByIdQuery,
  useLazyGetTrainByIdQuery, 
  useUpdateTaggerMutation, 
  useTrainPublishMutation, 
  useGetTrainsQuery, 
  useLazyGetTrainsQuery,
  useDeleteTaggerMutation} = userApi;
